<template>
    <v-card>
        <v-row cols="3">
            <v-col class="ma-4">
                <btn_component type="text" text="All"       :color="colorAll"       tooltip="All pending changes"       size="x-small" data="All" @actionClick="selectView"/>
                <btn_component type="text" text="Support"   :color="colorSupport"   tooltip="To be approved by Support" size="x-small" data="Support" @actionClick="selectView" v-if="!isAgentView"/>
                <btn_component type="text" text="Finance"   :color="colorFinance"   tooltip="To be approved by Finance" size="x-small" data="Finance" @actionClick="selectView" v-if="!isAgentView"/>
                <!-- <btn_component type="text" text="Agent"     :color="colorAgent"     tooltip="To be approved by Agent"   size="x-small" data="Agent" @actionClick="selectView"/> -->
                <btn_component type="text" text="Automatic" :color="colorAutomatic" tooltip="Automatic changes"         size="x-small" data="Automatic" @actionClick="selectView"/>
                <btn_component type="text" text="Manual"    :color="colorManual"    tooltip="Manual changes"            size="x-small" data="Manual" @actionClick="selectView"/>
            </v-col>
            <v-col class="mx-4">
                <v-card-title class="justify-center" v-if="!isAgentView">Overview of pending change requests</v-card-title>
                <v-card-title class="justify-center" v-if="isAgentView">Overview of onboarding change requests</v-card-title>
            </v-col>
            <v-col class="ma-4">
                <v-spacer></v-spacer>
                <span class="mx-2">{{ selected.length }} changes selected</span>
                <btn_component type="avatar_icon" color="green" tooltip="Approve selected changes" icon="mdi-check-circle-outline" :data="true" @actionClick="approveDeclineWzvzSelected"/>
                <btn_component type="avatar_icon" color="red" tooltip="Decline selected changes" icon="mdi-close-circle-outline" :data="false" @actionClick="approveDeclineWzvzSelected"/>
                <btn_component type="text" text="Remark" color="primary" tooltip="Approve/Decline selected changes with a remark" size="x-small" data="" @actionClick="approveDeclineRemark"/>
                <btn_component type="text" text="Select all" color="primary" tooltip="Select all changes" size="x-small" :data="true" @actionClick="selectAll"/>
                <btn_component type="text" text="Clear" color="primary" tooltip="Clear selection" size="x-small" :data="false" @actionClick="selectAll"/>
                <btn_component class="pl-16" type="avatar_text" text="A" color="primary" tooltip="Audit" size="default" data="" @actionClick="openAudit"/>
            </v-col>
        </v-row>
        <v-divider></v-divider>
    </v-card>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    
    export default {
        components: {
            btn_component,
        },   
        props: {
            filter: {
                type: String,
                required: true
            }
        },         
        data() {
            return {
                isAgentView: false,
                selected: [],
                selection: "All",
                colorAll: "primary",
                colorSupport: "grey",
                colorFinance: "grey",
                colorAgent: "grey",
                colorAutomatic: "grey",
                colorManual: "grey",
            }
        },    
        methods: {  
            selectView(newView) {
                this.selection = [];
                if (newView === "Agent") {
                    this.isAgentView = true;
                }
                if (this.isAgentView) {
                    this.colorAgent = "primary";
                }
                if (newView === "All") {
                    this.colorAll = "primary";
                    this.colorSupport = "grey";
                    this.colorFinance = "grey";
                    this.colorAgent = "grey";
                    this.colorAutomatic = "grey";
                    this.colorManual = "grey";
                    this.selection = ["All"]; 
                    if (this.isAgentView) {
                        this.colorAgent = "primary";
                        this.selection.push("Agent");
                    }                                 
                } else {
                    this.colorAll = "grey";
                }
                if (newView === "Support") {
                    this.colorSupport = this.colorSupport === "grey" ? "primary" : "grey";
                }
                if (newView === "Finance") {
                    this.colorFinance = this.colorFinance === "grey" ? "primary" : "grey";
                }
                // if (newView === "Agent") {
                //     this.colorAgent = this.colorAgent === "grey" ? "primary" : "grey";
                // }
                if (newView === "Automatic") {
                    this.colorAutomatic = this.colorAutomatic === "grey" ? "primary" : "grey";
                }
                if (newView === "Manual") {
                    this.colorManual = this.colorManual === "grey" ? "primary" : "grey";
                }
                // if ((this.colorSupport === "grey")&&(this.colorFinance === "grey")&&(this.colorAgent === "grey")&&(this.colorAutomatic === "grey")&&(this.colorManual === "grey")) {
                if ((!this.isAgentView)&&(this.colorSupport === "grey")&&(this.colorFinance === "grey")&&(this.colorAutomatic === "grey")&&(this.colorManual === "grey")) {
                    this.colorAll = "primary";
                    this.selection = ["All"];
                }
                // if ((this.colorSupport === "grey")&&(this.colorFinance === "grey")&&(this.colorAgent === "grey")&&(this.colorAutomatic === "grey")&&(this.colorManual === "grey")) {
                if ((this.isAgentView)&&(this.colorAutomatic === "grey")&&(this.colorManual === "grey")) {
                    this.colorAll = "primary";
                    this.selection = ["All"];
                    if (this.isAgentView) {
                         this.selection.push("Agent");
                    }
                }
                if (this.selection.length === 0) {
                    if (this.colorSupport === "primary") {
                        this.selection.push("Support");
                    }
                    if (this.colorFinance === "primary") {
                        this.selection.push("Finance");
                    }
                    if (this.colorAgent === "primary") {
                        this.selection.push("Agent");
                    }
                    if (this.colorAutomatic === "primary") {
                        this.selection.push("Automatic");
                    }
                    if (this.colorManual === "primary") {
                        this.selection.push("Manual");
                    }
                }
                this.$emit("updateView", this.selection);
            },  
            updateSelection(newValue) {
                this.selected = newValue;
            },
            selectAll(newValue) {
                this.$emit("selectAll", newValue);
            },
            approveDeclineWzvzSelected(approve) {
                this.$emit("approveDeclineWzvzSelected", approve);
            },
            approveDeclineRemark() {
                this.$emit("approveDeclineRemark");
            },
            openAudit() {
                this.$router.push({ path: "/wzvz/wzvz_cs_overview_all/" + this.filter});
            },
        }
    }
</script>

<style scoped> 

</style>